<script setup>

import HierarchyUsersList from '../components/HierarchyUsersList'
import Menu from '../components/Menu'

import { onMounted, onBeforeUnmount, ref, watch } from 'vue'
import { HUB } from '../hub'
import { Gems } from '../gems'
import { useStore } from "vuex"

const store = useStore()
let usersSearched = ref([])
let showAll = ref(false)
let showCEOConfirmation = ref(false)
let ceoUsersToConfirm = ref([])
let showCEORemovalConfirmation = ref(false)
let ceoToRemove = ref(null)
const ceoConfirmationMessage = 'Tem a certeza que pretende tornar este utilizador CEO da empresa? Esta ação irá colocar este utilizador no nível mais alto da hierarquia.'
const dragScrollState = {
    active: false,
    rafId: null,
    lastEvent: null,
}

/**
 * Automatically scrolls the window while dragging an element near the edges.
 * @param {DragEvent} e - The drag event.
 */
function AutoScrollWhileDragging(e) {
    if (!dragScrollState.active)
        return

    dragScrollState.lastEvent = e

    if (dragScrollState.rafId)
        return

    dragScrollState.rafId = requestAnimationFrame(() => {
        dragScrollState.rafId = null

        const event = dragScrollState.lastEvent
        if (!event)
            return

        const threshold = 80
        const speed = 30
        const viewportHeight = window.innerHeight

        if (event.clientY < threshold)
            window.scrollBy(0, -speed)
        else if (viewportHeight - event.clientY < threshold)
            window.scrollBy(0, speed)
    })
}

function StartDragScroll(e) {
    dragScrollState.active = true
    AutoScrollWhileDragging(e)
}

function StopDragScroll() {
    dragScrollState.active = false
    dragScrollState.lastEvent = null

    if (dragScrollState.rafId) {
        cancelAnimationFrame(dragScrollState.rafId)
        dragScrollState.rafId = null
    }
}

async function FilterUsers(search_text = "") {

    const response = await HUB.CallBackEnd({
        action: HUB.Action('get-hierarchy-users'),
        data: { search_text }
    })

    usersSearched.value = response.data
}

function Drag(e, user) {
    let selectedUsers = usersSearched.value.filter(user => user.selected)
    const inArray = selectedUsers.findIndex(elem => elem.user_id == user.user_id)
    if (inArray == -1)
        selectedUsers.push(user)

    const container = document.createElement('div')

    selectedUsers.forEach(us => {
        const user = document.createElement('div')
        const divData = document.createElement('div')
        const spanName = document.createElement('div')
        const spanJob = document.createElement('div')

        user.className = 'searched-user-data-drag'
        divData.className = 'user-txt'
        spanName.className = 'line-clamp line-clamp-1'
        spanJob.className = 'line-clamp line-clamp-1'

        spanName.innerHTML = us.name
        spanJob.innerHTML = us.job_name

        divData.style.color = 'black'

        divData.appendChild(spanName)
        divData.appendChild(spanJob)

        user.appendChild(divData)
        container.appendChild(user)
    })

    store.dispatch('CreateDragPreview', { e, container })

    container.style.width = '500px'

    e.dataTransfer.setData('arrUsers', JSON.stringify(selectedUsers))
    e.dataTransfer.setData('actual-headship', JSON.stringify(false))
}

function DropCEO(e) {
    const users = JSON.parse(e.dataTransfer.getData('arrUsers'))

    if (users.length > 1) {
        Gems.Telegram(
            "Não é possível definir múltiplos CEO's. Para trocar o CEO, adicione primeiro o novo e remova o anterior.",
            'tele-not-allowed'
        )
        return
    }

    const alreadyCEO = Object.values(store.getters.Hierarchy)
        .some(user => user.user_id == users[0].user_id)

    if (alreadyCEO) {
        Gems.Telegram('Este utilizador já é CEO da empresa.', 'tele-success')
        return
    }

    ceoUsersToConfirm.value = users
    showCEOConfirmation.value = true
}

function CancelCEO() {
    showCEOConfirmation.value = false
    ceoUsersToConfirm.value = []
}

function RequestRemoveCEO(user) {
    ceoToRemove.value = user
    showCEORemovalConfirmation.value = true
}

function CancelRemoveCEO() {
    showCEORemovalConfirmation.value = false
    ceoToRemove.value = null
}

async function ConfirmRemoveCEO() {
    const user = ceoToRemove.value
    CancelRemoveCEO()

    await store.dispatch('RemoveHierarchy', user)
}

async function ConfirmCEO() {
    const users = ceoUsersToConfirm.value
    CancelCEO()

    store.commit('insertCEO', users)
    await store.dispatch('InsertHierarchy', { user: users })
    store.dispatch('GetHierarchy')
    FilterUsers(document.getElementById('input-search-users').value)
}

async function DropHierarchy({ user, e }) {
    const newHeadship = user.user_id
    const actualHeadship = JSON.parse(e.dataTransfer.getData('actual-headship'))
    const subordinates = JSON.parse(e.dataTransfer.getData('arrUsers'))

    store.dispatch('InsertHierarchy', { user, subordinates, newHeadship, actualHeadship })
    FilterUsers(document.getElementById('input-search-users').value)
}

onMounted(() => {
    window.addEventListener('dragstart', StartDragScroll)
    window.addEventListener('dragover', AutoScrollWhileDragging)
    window.addEventListener('dragend', StopDragScroll)
    store.dispatch('GetHierarchy')
    FilterUsers()
})

onBeforeUnmount(() => {
    window.removeEventListener('dragstart', StartDragScroll)
    window.removeEventListener('dragover', AutoScrollWhileDragging)
    window.removeEventListener('dragend', StopDragScroll)
    StopDragScroll()
})

watch(showAll, (e) => {
    showAll.value = !showAll.value
    if (e)
        document.querySelectorAll(".fa-plus-square").forEach(elem => elem.click())
    else
        document.querySelectorAll(".fa-minus-square").forEach(elem => elem.click())
})

</script>

<template>
    <div id="div-container" class="main-container-background">

        <Menu></Menu>

        <div class="page-container">
            <img class="img-inpeople-default" src="../images/inpeople.png">

            <input type="text" id="input-search-users" class="input-search-users" @keyup="FilterUsers($event.target.value)"
                placeholder="Pesquisar utilizador..." />

            <div class="users-list scrollbar">
                <div v-for="(user, i) in usersSearched" :key="i">
                    <div class="searched-user-data" draggable="true" @dragstart="StartDragScroll($event); Drag($event, user)"
                        @dragend="StopDragScroll(); store.dispatch('DeleteDragPreview')">
                        <input type="checkbox" class="chk-multiple-users" :checked="user.selected" 
                            @click="user.selected = !user.selected"
                            @mouseenter="Gems.Tooltip($event.target, 'Selecionar', 'tooltip')" />

                        <div class="user-txt" @mouseenter="Gems.Tooltip($event.target, `Nº ${user.internal}`, 'tooltip')">
                            <span class="line-clamp line-clamp-1" :class="{ 'inactive-user': !user.active }">{{ user.name
                            }}</span>
                            <span class="line-clamp line-clamp-1" :class="{ 'inactive-user': !user.active }">{{ user.job_name }}</span>
                            <span class="line-clamp line-clamp-1" :class="{ 'inactive-user': !user.active }" v-if="user.headship_name">[{{ user.headship_name
                            }}]</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hierarchy-tree">

                <div class="ceos-drop-container">
                    <div class="ceos-drop-space" @dragover.prevent @drop="DropCEO($event)">
                        <div id="div-ceos-drop-space-hint">
                            Arraste um utilizador para AQUI para torná-lo "CEO" [Nível mais alto da hierárquia]
                        </div>
                    </div>
                    <div class="show-all-container clickable" @click="showAll = !showAll">
                        <i class="icon fas" :class="{ 'fa-plus-square': !showAll, 'fa-minus-square': showAll }" />
                        <span>Expandir/Fechar tudo</span>
                    </div>
                </div>

                <div class="user-row">
                    <HierarchyUsersList :hierarchy="store.getters.Hierarchy" @drop-hierarchy="DropHierarchy($event)"
                        @confirm-remove-ceo="RequestRemoveCEO($event)" />
                </div>

            </div>
        </div>

        <Teleport to="body">
            <div v-if="showCEOConfirmation" class="div-modal hierarchy-confirmation-modal">
                <div class="div-modal-content">
                    <h2 class="modal-title">Confirmar CEO</h2>
                    <p class="ceo-confirmation-message">{{ ceoConfirmationMessage }}</p>
                    <div class="ceo-confirmation-btns">
                        <div class="inputs-border hover-inputs-border">
                            <button class="button clickable" @click="ConfirmCEO()">
                                CONFIRMAR
                            </button>
                        </div>
                        <div class="inputs-border hover-inputs-border">
                            <button class="button clickable" @click="CancelCEO()">
                                CANCELAR
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showCEORemovalConfirmation" class="div-modal hierarchy-confirmation-modal">
                <div class="div-modal-content">
                    <h2 class="modal-title">Remover CEO</h2>
                    <p class="ceo-confirmation-message">
                        Tem a certeza de que pretende remover o CEO da empresa? Esta ação irá eliminar toda a hierarquia da
                        empresa associada a este CEO e não pode ser desfeita.
                    </p>
                    <div class="ceo-confirmation-btns">
                        <div class="inputs-border hover-inputs-border">
                            <button class="button clickable" @click="ConfirmRemoveCEO()">
                                CONFIRMAR
                            </button>
                        </div>
                        <div class="inputs-border hover-inputs-border">
                            <button class="button clickable" @click="CancelRemoveCEO()">
                                CANCELAR
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<style>
.searched-user-data,
.searched-user-data-drag {
    display: grid;
    grid-template-columns: 12px 97%;
    cursor: pointer;
    gap: 10px;
}

.searched-user-data-drag {
    grid-template-columns: 100%;
    width: 100%;
}

.searched-user-data-drag .user-txt {
    grid-template-columns: 50% 50%;
    display: grid;
}
</style>

<style scoped>
.searched-user-data,
.searched-user-data-drag {
    display: grid;
    grid-template-columns: 12px 97%;
    cursor: pointer;
    gap: 10px;
}

.searched-user-data-drag {
    grid-template-columns: 100%;
    width: 100%;
}

.searched-user-data-drag .user-txt {
    grid-template-columns: 50% 50%;
}

.inactive-user {
    opacity: 0.3;
}

.chk-multiple-users {
    margin: 0;
    transform: scale(1.5);
    cursor: pointer;
}

.user-txt {
    display: grid;
    grid-template-columns: 40% 55%;
    gap: 10px;
    color: var(--light-gray-color);
}

#div-container {
    display: flex;
    min-height: 100vh;
}

.page-container {
  width: initial;
  display: flex;
  flex-direction: column;
  padding: 25px 14px;
}

.img-inpeople-default {
    margin-bottom: 20px;
}

.users-list,
.ceos-drop-container,
.input-search-users {
    width: 70%;
    border-radius: 7px;
    border: none;
    font-size: .8em;
}

.users-list,
.input-search-users {
    background-color: #231f20;
}

.users-list {
    height: 150px;
    overflow: hidden auto;
    padding: 5px 10px;
}

.user-txt {
    display: grid;
    grid-template-columns: 35% 35% 30%;
    gap: 10px;
}

.hierarchy-tree {
    margin-top: 20px;
    min-width: 1700px;
}

.ceos-drop-container {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
}

.ceos-drop-space {
    border-radius: 7px;
    padding: 2px;
    backdrop-filter: blur(10px);
    box-shadow: 0 0 10px 2px #ffffff10;
    cursor: default;
    width: 79%;
    background-image: var(--input-gradient-border);
}

.ceos-drop-space div {
    background-color: black;
    border-radius: 5px;
    height: 34px;
    display: flex;
    align-items: center;
    padding-left: 10px;
}

.show-all-container {
    min-width: -moz-fit-content;
    min-width: fit-content;
    padding: 0 3% 0 20px;
}

.show-all-container i {
    margin-right: 10px;
}

.show-all-container:hover {
    color: var(--default-hover-color);
}

.modal-title {
    margin: 0 0 10px 0;
    color: rgb(135 255 165);
}

.ceo-confirmation-message {
    margin: 0;
}

.ceo-confirmation-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 5px;
}

.ceo-confirmation-btns .inputs-border {
    min-width: 30%;
}

.ceo-confirmation-btns .button {
    height: 100%;
}

.hierarchy-confirmation-modal {
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 4vh 16px;
    overflow-y: auto;
}

.hierarchy-confirmation-modal::before {
    display: none;
}

.hierarchy-confirmation-modal .div-modal-content {
    margin: 0 auto;
    max-height: calc(100vh - 8vh);
    overflow-y: auto;
    box-sizing: border-box;
}

.user-row:only-child {
    padding: 1%;
}

.searched-user-data {
    display: grid;
    grid-template-columns: 12px 97%;
    cursor: move;
    gap: 10px;
}

.input-search-users {
    padding: 10px;
    margin-bottom: 10px;
    color: white;
}

.input-search-users::placeholder {
    color: white;
}

.chk-multiple-users {
    margin: 0;
    transform: scale(1.2);
    cursor: pointer;
}

.inactive {
    opacity: .3;
}

@media only screen and (max-width: 768px) {

    #div-container {
        overflow: auto;
    }

    .hierarchy-tree {
        min-width: 1200px;
    }
}

@media only screen and (max-width: 800px) {
    .ceo-confirmation-btns .button {
        font-size: .9em;
    }
}
</style>
